/** @format */

import { useEffect, useState } from "react";
import { LoginType, SSO_TYPE } from "interfaces";
import { ArtButton } from "components/button";
import { EphemeralKeyPair } from "@aptos-labs/ts-sdk";
import { jwtDecode } from "jwt-decode";
import { api } from "services";
import { store } from "reducer/store";
import { bulkSetUserInfo } from "reducer/user.slice";
const clientId = process.env.REACT_APP_CLIENT_ID;

export const storeEphemeralKeyPair = (ekp: EphemeralKeyPair): void =>
  localStorage.setItem("@aptos/ekp", encodeEphemeralKeyPair(ekp));
export const encodeEphemeralKeyPair = (ekp: EphemeralKeyPair): string =>
  JSON.stringify(ekp, (_, e) => {
    if (typeof e === "bigint") return { __type: "bigint", value: e.toString() };
    if (e instanceof Uint8Array)
      return { __type: "Uint8Array", value: Array.from(e) };
    if (e instanceof EphemeralKeyPair)
      return { __type: "EphemeralKeyPair", data: e.bcsToBytes() };
    return e;
  });

/**
 * Parse the ephemeral key pairs from a string
 */
export const decodeEphemeralKeyPair = (encodedEkp: string): EphemeralKeyPair =>
  JSON.parse(encodedEkp, (_, e) => {
    if (e && e.__type === "bigint") return BigInt(e.value);
    if (e && e.__type === "Uint8Array") return new Uint8Array(e.value);
    if (e && e.__type === "EphemeralKeyPair")
      return EphemeralKeyPair.fromBytes(e.data);
    return e;
  });
export const getLocalEphemeralKeyPair = (): EphemeralKeyPair | undefined => {
  try {
    const encodedEkp = localStorage.getItem("@aptos/ekp");
    return encodedEkp ? decodeEphemeralKeyPair(encodedEkp) : undefined;
  } catch (error) {
    console.warn(
      "Failed to decode ephemeral key pair from localStorage",
      error
    );
    return undefined;
  }
};
const parseJWTFromURL = (url: string): string | null => {
  const urlObject = new URL(url);
  const fragment = urlObject.hash.substring(1);
  const params = new URLSearchParams(fragment);
  return params.get("id_token");
};

// window.location.href = https://.../login/google/callback#id_token=...
export const SingleSignon = ({
  type,
  device,
  SSO_META,
}: {
  type: "signin" | "signup";
  device: "laptop" | "mobile";
  SSO_META: SSO_TYPE;
}) => {
  useEffect(() => {
    async function login() {
      const jwt = parseJWTFromURL(window.location.href);
      if (!jwt) return;
      const payload = jwtDecode<{ nonce: string }>(jwt);
      const jwtNonce = payload.nonce;
      console.log("jwttttttt", { jwt, jwtNonce });
      let rs = await api.post("/customer/login-support-customer", {
        type: 5,
        social_access_token: jwt,
      });
      sessionStorage.setItem("token", rs.token);
      store.dispatch(bulkSetUserInfo(rs.customerInfo));
    }
    login();
  }, []);
  const [isMetaMask, setIsMetaMask] = useState(true);
  const [openPopup, setOpenPopup] = useState("");
  async function onSiginClick() {
    const redirectUri = `${window.location.origin}`;
    console.log("redirect uri ", redirectUri);
    const ephemeralKeyPair = EphemeralKeyPair.generate();
    console.log("ephemeral ", ephemeralKeyPair);
    storeEphemeralKeyPair(ephemeralKeyPair);
    // Get the nonce associated with ephemeralKeyPair
    const nonce = ephemeralKeyPair.nonce;
    const loginUrl = `https://accounts.google.com/o/oauth2/v2/auth?response_type=id_token&scope=openid+email+profile&nonce=${nonce}&redirect_uri=${redirectUri}&client_id=${clientId}`;
    console.log("loginurl", loginUrl);
    window.location.href = loginUrl;
  }

  return (
    <ArtButton
      color={type === "signup" ? "red" : "yellow"}
      onClick={() => {
        onSiginClick();
      }}
    >
      <p className="px-4 m-0 py-0">Sign In</p>
    </ArtButton>
  );
};
